<template>
	<div class="wrapper">
		<parallax class="section page-header header-filter" :style="headerStyle"></parallax>
		<div class="main main-raised">
			<div class="section profile-content">
				<div class="container">
					<div class="md-layout">
						<div class="md-layout-item mx-auto">
							<div class="profile">
								<div class="avatar">
									<img :src="img" alt="Amrei Schaal Psychologische Psychotherapeutin Profilbild"
										class="
											img-raised
											rounded-circle
											img-fluid
										" />
								</div>
								<div class="name">
									<h3 class="title">Amrei Schaal</h3>
									<h6>Psychologische Psychotherapeutin</h6>
								</div>
							</div>
						</div>
					</div>
					<div class="description text-left">
						<h3>
							Probleme und deren Bew&auml;ltigung geh&ouml;ren zu unserem
							Alltag.
						</h3>
						<h3>
							Dauert die Belastung jedoch l&auml;nger an oder wird die
							Lebensqualit&auml;t und Alltagsbew&auml;ltigung dauerhaft
							beeintr&auml;chtigt, kann sich eine psychische Erkrankung
							entwickeln.
						</h3>
						<h3>
							Dann kann eine Therapie helfen, L&ouml;sungswege zu
							finden.
						</h3>
					</div>
					<div class="md-size-100 md-small-size-100 mt-30">
						<tabs :tab-name="['Ablauf', 'Kosten']" plain color-button="info">
							<!-- here you can add your content for tab-content -->
							<template slot="tab-pane-1">
								<div id="ablauf" class="md-layout">
									<div class="tim-typo">
										<div class="md-layout-item md-size-80">
											<h3>Ablauf</h3>
											<h4>
												Jede Therapie ist individuell
												und einzigartig. Bestimmte
												Konstanten im Vorgehen haben
												sich jedoch als
												Rahmenbedingungen bew&auml;hrt: In
												einem Erstgespr&auml;ch k&ouml;nnen Sie
												mir Ihre Problematik schildern
												und wir k&ouml;nnen die wichtigsten
												Fragen und Anliegen kl&auml;ren.
											</h4>
											<h4>
												Dabei kann ich eine erste
												diagnostische Einsch&auml;tzung
												vornehmen und feststellen, ob
												eine ambulante Psychotherapie
												indiziert ist. In den
												darauffolgenden Sitzungen geht
												es darum, Therapieziele zu
												definieren, die
												Entstehungsgeschichte Ihrer
												Probleme genauer anzuschauen und
												einen transparenten
												Behandlungsplan zu erstellen.
											</h4>
											<h4>
												Alle Interventionen und
												Vorgehensweisen entstehen
												hierbei immer in Kontakt und in
												Feinabstimmung mit Ihnen. Neben
												einer vertieften Diagnostik und
												einer ausf&uuml;hrlichen Anamnese
												dienen die insgesamt bis zu f&uuml;nf
												Stunden Probatorik auch dazu, die
												therapeutische Beziehung zu
												pr&uuml;fen.
											</h4>
											<h4>
												Studien haben gezeigt, dass eine
												gute Passung zwischen Klient
												und Therapeut einer der gr&ouml;ßten
												Wirkfaktoren f&uuml;r eine gelungene
												Therapie ist.
											</h4>
											<h4>
												Dementsprechend m&ouml;chte ich Sie
												ermutigen, diese ersten vier bis
												f&uuml;nf Sitzungen zu nutzen, um
												herauszufinden, ob Sie sich bei
												mir gut aufgehoben f&uuml;hlen und
												ich f&uuml;r Ihre Anliegen eine gute
												Ansprechpartnerin sein kann.
											</h4>
											<h4>
												Die Termine finden in der Regel
												w&ouml;chentlich statt und dauern 50
												Minuten. Die Inhalte der
												therapeutischen Gespr&auml;che
												unterliegen ab der ersten
												Kontaktaufnahme der &auml;rztlichen
												Schweigepflicht.
											</h4>
										</div>
									</div>
								</div>
							</template>
							<template slot="tab-pane-2">
								<div id="kosten" class="md-layout">
									<div class="tim-typo">
										<div class="md-layout-item md-size-80">
											<h3>Kosten</h3>
											<h4>
												Da ich in Privatpraxis t&auml;tig
												bin, kann ich vor allem mit
												Privatkassen, Beihilfe und
												Selbstzahlern abrechnen.
											</h4>
											<h4>
												Bei gesetzlichen Krankenkassen
												ist in einigen F&auml;llen die
												Kostenerstattung m&ouml;glich, was
												Sie am besten im Vorfeld mit
												Ihrer Kasse abkl&auml;ren sollten.
											</h4>
											<h4>
												Private Krankenversicherungen
												&uuml;bernehmen in der Regel die
												Kosten f&uuml;r eine ambulante
												Psychotherapie. Oft gibt es
												jedoch je nach Tarif
												Besonderheiten wie eine
												Beschr&auml;nkung der Sitzungsanzahl
												pro Jahr oder &auml;hnliches.
											</h4>
											<h4>
												Bitte informieren Sie sich daher
												vor Beginn der Therapie &uuml;ber die
												genauen Modalit&auml;ten, zu welchen
												Konditionen und in welchem
												Umfang Ihre Therapie &uuml;bernommen
												werden kann.
											</h4>
											<h4>
												Es besteht auch die
												M&ouml;glichkeit, die Therapie in
												Eigenleistung zu finanzieren.
												Bei Selbstzahlern orientieren
												sich die Kosten f&uuml;r die Therapie
												an der Geb&uuml;hrenordnung f&uuml;r
												Psychologische Psychotherapeuten
												(GOP).
											</h4>
										</div>
									</div>
								</div>
							</template>
						</tabs>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Tabs } from "@/components";
export default {
	components: {
		Tabs,
	},
	bodyClass: "profile-page",
	data() {
		return {
			tabPane1: [
				{ image: require("@/assets/img/examples/studio-2.jpg") },
				{ image: require("@/assets/img/examples/studio-2.jpg") },
				{ image: require("@/assets/img/examples/studio-4.jpg") },
				{ image: require("@/assets/img/examples/studio-5.jpg") },
			],
			tabPane2: [
				{ image: require("@/assets/img/practice/practice_01.jpeg") },
				{ image: require("@/assets/img/practice/practice_02.jpeg") },
				{ image: require("@/assets/img/practice/practice_03.jpeg") },
				{ image: require("@/assets/img/examples/studio-2.jpg") },
				{
					image: require("@/assets/img/examples/mariya-georgieva.jpg"),
				},
			],
			tabPane3: [
				{
					image: require("@/assets/img/cali-strokes.jpg"),
				},
				{ image: require("@/assets/img/examples/studio-3.jpg") },
				{ image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
				{ image: require("@/assets/img/examples/olu-eletu.jpg") },
				{ image: require("@/assets/img/examples/studio-1.jpg") },
			],
		};
	},
	props: {
		header: {
			type: String,
			// default: require("@/assets/img/examples/IMG_6143.jpeg"),
			default: require("@/assets/img/benjamin-voros-unsplash-mountain-stars__.jpeg"),
		},
		img: {
			type: String,
			default: require("@/assets/img/faces/amrei_11_done_3_auto_x2_minified.jpeg"),
		},
	},
	computed: {
		headerStyle() {
			return {
				backgroundImage: `url(${this.header})`,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.section {
	padding: 0;
}

.text-large {
	font-size: large;
}

.subhead:first-of-type:first-letter {
	font-size: xx-large;
	line-height: 1;
}

.no-pad {
	padding-left: unset;
}

.mt-30 {
	margin-top: 30px;
}

.tim-typo {
	margin-top: 40px;
	padding-left: 15%;
}

.profile-tabs::v-deep {
	.md-card-tabs .md-list {
		justify-content: center;
	}

	[class*="tab-pane-"] {
		margin-top: 3.213rem;
		padding-bottom: 50px;

		img {
			margin-bottom: 2.142rem;
		}
	}
}
</style>
